module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-03.1.c20d199c.jpg";